<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
    <div class="sidebar-next-right-block">
        <partner-dashboard></partner-dashboard>
    </div>
</div>

<p-toast position="top-right"></p-toast>
